import React from 'react';
import { FloorPriceData } from '../../types';
import { D3LineChart } from './D3LineChart';
import { useFilters } from '../../cube/filters';

interface FloorPriceBarProps {
  data: FloorPriceData[];
  colorScaleFunc?: (value: number) => string;
}

export const FloorPriceBar: React.FC<FloorPriceBarProps> = ({ data, colorScaleFunc }) => {
  const { filters, set } = useFilters();
  
  const chartData = React.useMemo(() => {
    const grouped = new Map<number, { totalPrice: number; totalCount: number }>();
    (data || []).forEach((d) => {
      const floor = Number(d.unit_per_floor);
      if (floor > 25) return;
      const price = Number(d.median_price_per_m2) || 0;
      const count = Number(d.listing_count) || 1;
      const existing = grouped.get(floor) || { totalPrice: 0, totalCount: 0 };
      grouped.set(floor, {
        totalPrice: existing.totalPrice + (price * count),
        totalCount: existing.totalCount + count
      });
    });
    return Array.from(grouped.entries())
      .map(([key, { totalPrice, totalCount }]) => ({
        key,
        value: totalCount > 0 ? totalPrice / totalCount : 0
      }))
      .sort((a, b) => a.key - b.key);
  }, [data]);

  const handleBrush = React.useCallback((range: [number, number] | null) => {
    if (!range) {
      set({ floor: undefined });
      return;
    }
    const [min, max] = range;
    const floors: number[] = [];
    for (let i = Math.ceil(min); i <= Math.floor(max); i++) {
      floors.push(i);
    }
    set({ floor: floors.length > 0 ? floors : undefined });
  }, [set]);

  return (
    <D3LineChart
      data={chartData}
      title="Preço Médio por m² por Andar"
      xLabel="Andar"
      yLabel="Preço Médio por m²"
      formatXTick={(k) => String(k)}
      formatYTick={(n) => `R$${Math.round(n)}`}
      onBrush={handleBrush}
      brushRange={filters.floor && filters.floor.length > 0 ? [Math.min(...filters.floor), Math.max(...filters.floor)] : null}
      colorScaleFunc={colorScaleFunc}
    />
  );
};


